export function selectRules(state, conditionId) {
  return state.rules
    .filter((rule) => rule.get('conditionId') === conditionId)
    .toList()
    .sort((a, b) => a.created_at > b.created_at)
    .toJS();
}

export function selectMaxRulePosition(state, conditionId) {
  return selectRules(state, conditionId).reduce(
    (maxPosition, rule) => Math.max(maxPosition, rule.afterPosition),
    0,
  );
}

export function selectRule(state, ruleId) {
  const rule = state.rules.get(ruleId);
  return rule && rule.toJS();
}
